var map = {
	"./acid-resistant.png": "514c",
	"./alcohol-resistant.png": "f1d0",
	"./biobased.png": "b500",
	"./bowl.png": "f5ee",
	"./closable-with-lid.png": "7ed4",
	"./compostable-with-houseinternal-composting-machine-eg-ecocreation.png": "9dd2",
	"./cup.png": "e6f9",
	"./customizable.png": "72f5",
	"./cutlery.png": "d374",
	"./dot-alert-big.png": "f6cb",
	"./dot-alert.png": "4c36",
	"./fat-resistant.png": "cce6",
	"./freezer-safe.png": "f1f8",
	"./from-recycled-material-pcr.png": "cf26",
	"./from-recycled-material-pir.png": "8cd1",
	"./hot-fillable-usable-for-hot-foodstuffs-for-cutlery.png": "bf9f",
	"./ico_prohibicion.png": "100f",
	"./ico_reduccion.png": "ed75",
	"./info-hover.png": "fbaa",
	"./info.png": "2226",
	"./login/EU_directive.png": "c8cb",
	"./login/fondo_login.png": "949c",
	"./login/invitation.png": "e464",
	"./login/smile.png": "5f99",
	"./login/ue.png": "d8e9",
	"./logo.png": "4ffd",
	"./microwaveable.png": "0fd6",
	"./natural-material.png": "edf3",
	"./oven-safe.png": "9460",
	"./power.png": "7401",
	"./recyclable-only-water-clean.png": "9e0c",
	"./recyclable-with-greasy-food-contact.png": "12762",
	"./sealable-with-foil.png": "db6a",
	"./transparent.png": "3be7",
	"./ue_mobile.png": "5d42",
	"./water-resistant.png": "4699"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";